// extracted by mini-css-extract-plugin
module.exports = {"block":"InputWrap_block__2e_1b","titleWrap":"InputWrap_titleWrap__KzFaL","title":"InputWrap_title__2XFLh","input":"InputWrap_input__OzDzu"};